import { render, staticRenderFns } from "./CreateUpdateModal.vue?vue&type=template&id=6e40e072&scoped=true"
import script from "./CreateUpdateModal.vue?vue&type=script&lang=js"
export * from "./CreateUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdateModal.vue?vue&type=style&index=0&id=6e40e072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e40e072",
  null
  
)

export default component.exports